import { FC } from 'react';
import styled from 'styled-components';

import { AttributeColumn } from 'dashboard/models/table-view';
import Table, { TableHead, TableHeaderCell, TableRow } from 'design-system/components/Table';

export const PlatformNodeTable = styled(Table)`
  table-layout: fixed;
`;

interface NodeTableHeaderProps {
  columns: AttributeColumn[];
}

export const PlatformNodeTableHeader: FC<NodeTableHeaderProps> = ({ columns }) => {
  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => {
          return (
            <TableHeaderCell id={`platform-node-table__header--${column.key}`} key={column.key}>
              {column.label}
            </TableHeaderCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};
